import { ChangeDetectionStrategy, Component, ElementRef, Input, OnInit } from '@angular/core';
import { getInitials, isInsideControl } from '@shared/helpers';

// A person's picture, or their initials in a grey circle when there's none. Their name is in a toggletip: a button
// named with it that shows it on hover, focus or press (ToggletipDirective), so keyboard and touch users get it too
@Component({
    selector: 'app-avatar',
    templateUrl: './avatar.component.html',
    styleUrls: ['./avatar.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AvatarComponent implements OnInit {
  static readonly componentName = 'AvatarComponent';

  // the person's "Last, First" name, which also gives the initials
  @Input() name: string;
  @Input() image: string;
  // what the tooltip and screen readers say when it's more than the name (e.g. "Sent by Doe, John")
  @Input() label: string;

  // inside a control (e.g. a button that assigns an administrator) the avatar can't be a button of its own: it then
  // stays a plain picture or circle (the control carries any tooltip), with hidden text that's read with the control
  public insideControl = false;

  constructor(private el: ElementRef<HTMLElement>) {}

  get initials(): string {
    return getInitials(this.name);
  }

  // the avatar's own template hasn't been checked yet, so it renders the right way the first time
  ngOnInit(): void {
    this.insideControl = isInsideControl(this.el.nativeElement);
  }
}
